import type { ActionsOfCreators, FeatureHandler } from '../helpers';

export const outputActions = [];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
